module.exports = __webpack_public_path__ + "static/NotoKufiArabic-f9fb35efab494265aa456da9562f2d9c.woff";